// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linkedTabs[data-v-853c7aca]{background:#4a381c;border-radius:5px 5px 0 0;display:flex;list-style-type:none;margin:0;padding:0}.linkedTabs--round[data-v-853c7aca]{background:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
